import { useReveal } from "@/hooks/useReveal";
import { UFJ_IMAGES } from "./data";

export default function UFJEditorial({ onInquire }) {
  const eyebrow = useReveal();
  const title = useReveal();
  const body = useReveal();
  const img = useReveal();

  return (
    <section
      data-testid="ufj-editorial"
      className="relative bg-black py-28 md:py-40 overflow-hidden grain"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">
        <div ref={img} className="pd-reveal lg:col-span-7 order-2 lg:order-1">
          <div className="relative aspect-[4/5] overflow-hidden border border-[var(--pd-border)]">
            <img
              src={UFJ_IMAGES.editorial}
              alt="Signature high jewelry piece — concept imagery"
              className="w-full h-full object-cover transition-transform duration-[2400ms] hover:scale-105"
              data-testid="ufj-editorial-image"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent" />
            <div className="absolute top-4 left-4">
              <span className="text-[0.55rem] uppercase tracking-[0.42em] text-white/55 bg-black/60 backdrop-blur px-3 py-1.5">
                Concept Imagery
              </span>
            </div>
            <div className="absolute bottom-5 left-5 right-5 flex items-end justify-between">
              <div>
                <p className="eyebrow text-white/70">Signature Chapter</p>
                <p className="font-serif-display text-xl md:text-2xl text-white mt-1 tracking-[0.14em]">
                  Haute Joaillerie
                </p>
              </div>
              <span className="text-[0.6rem] uppercase tracking-[0.4em] text-[var(--pd-gold)]">
                Private Audience
              </span>
            </div>
          </div>
        </div>

        <div className="lg:col-span-5 order-1 lg:order-2">
          <p ref={eyebrow} className="pd-reveal eyebrow" data-testid="ufj-editorial-eyebrow">
            An editorial, not a catalogue
          </p>
          <h2
            ref={title}
            className="pd-reveal mt-6 font-serif-display text-4xl md:text-5xl lg:text-6xl text-white tracking-[0.06em] leading-[1.06]"
            style={{ transitionDelay: "160ms" }}
            data-testid="ufj-editorial-title"
          >
            Every piece, <br />
            <span className="italic font-serif-body text-white/85">a quiet statement.</span>
          </h2>
          <div ref={body} className="pd-reveal mt-8 space-y-5" style={{ transitionDelay: "320ms" }}>
            <p className="font-light text-white/70 text-base md:text-lg leading-relaxed tracking-wide">
              The maison does not publish inventory. Available pieces are introduced through
              private correspondence, during appointments in Monaco, Geneva, and selected
              residences worldwide.
            </p>
            <p className="font-light text-white/55 text-sm leading-relaxed">
              Specifications, provenance and certification are shared with the client at the
              moment of consideration — not before.
            </p>

            <div className="pt-6 border-t border-white/10 flex items-center justify-between">
              <span className="eyebrow">Status</span>
              <span className="font-serif-body text-white/80">By Private Appointment</span>
            </div>
            <div className="flex items-center justify-between pb-2 border-b border-white/10">
              <span className="eyebrow">Pricing</span>
              <span className="font-serif-display text-[var(--pd-gold)] tracking-[0.1em]">
                Price Upon Request
              </span>
            </div>

            <button
              onClick={() => onInquire?.({ name: "Haute Joaillerie Audience", key: "editorial" })}
              data-testid="ufj-editorial-cta"
              className="btn-gold mt-6"
            >
              <span>Inquire Privately</span>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
